import React from 'react'
import { Button } from '@repo/ui'
import { workosAuthService } from 'services/workos-auth.service'

type Props = {
  onLinked?: () => void
  /** Button text. Defaults to the sign-in wording; the access form says "Continue with Google". */
  label?: string
  /** Extra classes, e.g. `w-full` to span a card. */
  className?: string
  disabled?: boolean
  /**
   * Runs just before the redirect to Google, on the tap. VRG-720: this is where the access
   * form records WHERE to come back to and what the visitor was doing. Returning `false`
   * cancels the redirect (e.g. a required location could not be acquired).
   */
  onBeforeRedirect?: () => boolean | void | Promise<boolean | void>
  /**
   * VRG-720 — the brand to sign the owner in under. Wins over `sessionStorage.companyId`,
   * which a public certificate page does not set, so a claim or access request from one sent
   * no company at all and only worked where the subdomain happened to supply it.
   */
  companyId?: string
}

export const GoogleLoginButton = ({ onLinked, label = 'Sign in with Google', className, disabled, onBeforeRedirect, companyId: companyIdProp }: Props) => {
  const handleGoogleSignIn = async () => {
    if (onBeforeRedirect && (await onBeforeRedirect()) === false) return
    // Get embedd context if available
    const embeddKey = sessionStorage.getItem('embeddKey')
    const companyId = companyIdProp || sessionStorage.getItem('companyId')

    workosAuthService.loginWithGoogle({
      embeddKey: embeddKey || undefined,
      companyId: companyId || undefined,
    })
  }

  return (
    <Button 
      sx={{ paddingX: 2 }}
      variant="secondary"
      className={className}
      disabled={disabled}
      onClick={handleGoogleSignIn}
    >
      <svg className='mr-2' width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        <path fill="none" d="M0 0h48v48H0z"/>
      </svg>
      {label}
    </Button>
  )
}
